
import React from "react";

export default function HomePage() {
  return (
    <div className="bg-white text-gray-800">
      {/* Hero Section */}
      <section className="bg-cover bg-center min-h-[80vh] flex flex-col justify-center items-center text-white text-center px-4" style={{ backgroundImage: "url('/kaaba.jpg')" }}>
        <h1 className="text-4xl md:text-6xl font-bold drop-shadow-md">Umrah Packages to the Holy Cities of Makkah and Madinah</h1>
        <p className="mt-4 text-lg max-w-xl drop-shadow-sm">
          Experience a spiritually uplifting journey with Al Haramain Foundation
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-4">
          <button className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-xl text-white font-semibold shadow">View Packages</button>
          <button className="bg-white text-blue-600 hover:bg-blue-100 px-6 py-3 rounded-xl font-semibold shadow">Register Interest</button>
        </div>
      </section>

      {/* Register Interest Section */}
      <section className="py-16 px-6 bg-gray-50 text-center">
        <h2 className="text-3xl font-bold mb-4">Register Your Interest</h2>
        <p className="text-lg mb-6 max-w-2xl mx-auto">
          Stay informed about future Al Haramain Foundation Umrah packages and special events. Sign up below and we’ll keep you connected.
        </p>
        <form className="flex flex-col sm:flex-row gap-4 justify-center max-w-xl mx-auto">
          <input type="email" placeholder="Your email address" className="px-4 py-3 rounded-xl border border-gray-300 w-full" />
          <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-700">Sign Up</button>
        </form>
      </section>

      {/* Footer */}
      <footer className="bg-gray-100 py-6 text-center text-sm text-gray-600">
        <p>© {new Date().getFullYear()} Al Haramain Foundation</p>
        <p>
          <a href="https://wa.me/yourwhatsapplink" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
            Chat with us on WhatsApp
          </a>
        </p>
      </footer>
    </div>
  );
}
